/**
 * Подготавливаем недобровольную причину trip_canceled среди всех имеющихся
 */export const getInvoluntaryReason = reasons => reasons.find(reason => reason === 'trip_canceled');
/**
 * Подготавливаем добровольную причину возврата среди всех имеющихся
 */
export const getVoluntaryReason = reasons => reasons.find(reason => reason === 'voluntary');